import React, {useContext, useEffect, useState} from 'react'
import s from './SideBar.module.scss'
import textLogo from 'Static/Logo/nxstep-white.svg';
import {isLoggedIn, SessionContext} from 'Utils/sessions'
import {
    RiBaseStationFill,
    RiCalendar2Fill,
    RiCamera2Line,
    RiClipboardFill,
    RiLoginBoxLine,
    RiLogoutBoxLine,
    RiMailFill,
    RiMoneyDollarCircleFill,
    RiNumbersLine,
    RiUser3Line
} from 'react-icons/ri';
import {AiOutlineForm, AiOutlineMenu} from 'react-icons/ai';
import {SidebarItem} from 'react-responsive-sidebar';
import Notifications from './Notifications'
import avi from 'Static/default-avi.png';
import {clearSessionCookie} from "../../Utils/sessions";
import Button from "react-bootstrap/Button";
import {AdminApi} from "../../Api/AdminApi";

const UnreadMessageIndicator = ({}) => {
    const {session} = useContext(SessionContext);
    const [notificationCount, setNotificationCount] = useState(null)

    useEffect(() => {
        if (isLoggedIn()) {
            AdminApi.Messaging.getUnreadMessageCount(session.jwt)
                .then((rsp) => {
                    if (typeof rsp.data === 'number' && !Number.isNaN(rsp.data) && rsp.data > 0) {
                        setNotificationCount(rsp.data)
                    } else {
                        setNotificationCount(null)
                    }
                })
                .catch((err) => {
                    setNotificationCount(null)
                })
        }
    }, []);

    useEffect(() => {
        if (isLoggedIn()) {
            navigator.serviceWorker.addEventListener('message', event => {
                if (event.data.type === 'notification-received') {
                    AdminApi.Messaging.getUnreadMessageCount(session.jwt)
                        .then((rsp) => {
                            if (typeof rsp.data === 'number' && !Number.isNaN(rsp.data) && rsp.data > 0) {
                                setNotificationCount(rsp.data)
                            } else {
                                setNotificationCount(null)
                            }
                        })
                        .catch((err) => {
                            setNotificationCount(null)
                        })
                }
            });

            return () => {
                navigator.serviceWorker.removeEventListener('message', handleMessage);
            };
        }
    }, []);

    useEffect(() => {
        if (isLoggedIn()) {
            document.addEventListener('new-notification-received', (event) => {
                AdminApi.Messaging.getUnreadMessageCount(session.jwt)
                    .then((rsp) => {
                        if (typeof rsp.data === 'number' && !Number.isNaN(rsp.data) && rsp.data > 0) {
                            setNotificationCount(rsp.data)
                        } else {
                            setNotificationCount(null)
                        }
                    })
                    .catch((err) => {
                        setNotificationCount(null)
                    })
            });

            document.addEventListener('thread-marked-read', (event) => {
                AdminApi.Messaging.getUnreadMessageCount(session.jwt)
                    .then((rsp) => {
                        if (typeof rsp.data === 'number' && !Number.isNaN(rsp.data) && rsp.data > 0) {
                            setNotificationCount(rsp.data)
                        } else {
                            setNotificationCount(null)
                        }
                    })
                    .catch((err) => {
                        setNotificationCount(null)
                    })
            });
        }
    }, []);

    const handleMessage = (event) => {
        if (event.data.type === 'push-received') {
            console.log('Message from service worker:', event.data.message);
            // Perform actions in your app based on the message
            alert(event.data.message)
        }
    }

    return <>
        {notificationCount && <span className={'ms-2'}>({notificationCount})</span>}
    </>
}


const Header = ({title, onMenuClick }) => {
    const {session} = useContext(SessionContext);

    function handleMenuClick() {
        if (onMenuClick) {
            onMenuClick()
        }
    }

    return <>
        <div className={s.headerNoSearch}>
            <h2 className={s.title}>{title}</h2>

            <div className={`${s.revealSidebarButtonContainer}`}>
                <Button className={`btnLink`} onClick={handleMenuClick}><AiOutlineMenu color={'white'} size={28}/></Button>
            </div>

            {session.jwt && <span className={`d-flex align-content-center justify-content-end`}>
            <Notifications className={s.notifications}/>
            <span className={`${s.profile}`}>
                <div className={s.profileAvatar}
                     style={{backgroundImage: `url(${session.photo || avi})`, backgroundSize: 'cover'}}/>
                <div className='ms-2 trunc'>
                    <span><strong>{session.firstName} {session.lastName}</strong></span>
                    <span className='text-muted d-block'>@{session.userName}</span>
                </div>
            </span>
        </span>}
        </div>
    </>
}

const SideBarContainer = ({session, title, search = true, placeholder, searchBarSuggestions, onSearchQueryChange, onSearch, ...props}) => {
    const [sidebarShown, setSidebarShown] = useState(false)

    const items = [
        <SidebarItem href={'/dashboard'}><img
            alt=""
            src={textLogo}
            height="35"
            className="d-inline-block align-center"
        /></SidebarItem>,
    ]

    if (!isLoggedIn()) {
        items.push(
            <SidebarItem href='/register'><span className={s.link}><AiOutlineForm/>{' '}Register</span></SidebarItem>,
            <SidebarItem href='/login'><span className={s.link}><RiLoginBoxLine/>{' '}Login</span></SidebarItem>,
        )
    } else {
        items.push(
            <SidebarItem href='/dashboard'>
                <span className={s.link}><RiClipboardFill/>
                    Dashboard
                </span>
            </SidebarItem>,
            <SidebarItem href='/users'>
                <span className={s.link}><RiUser3Line/>
                    Users
                </span>
            </SidebarItem>,
            <SidebarItem href='/growth'>
                <span className={s.link}><RiNumbersLine/>
                    Growth
                </span>
            </SidebarItem>,
            <SidebarItem href='/schedule'>
                <span className={s.link}><RiCalendar2Fill/>
                    Schedule
                </span>
            </SidebarItem>,
            <SidebarItem href='/notifications'>
                <span className={s.link}><RiBaseStationFill/>
                    Notifications
                </span>
            </SidebarItem>,
            <SidebarItem href='/media'>
                <span className={s.link}><RiCamera2Line/>
                    Media
                </span>
            </SidebarItem>,
            <SidebarItem href='/payments'>
                <span className={s.link}><RiMoneyDollarCircleFill/>
                    Payments
                </span>
            </SidebarItem>,
            <SidebarItem href='/support'>
                <span className={s.link}><RiMailFill/>
                    Support
                </span>
            </SidebarItem>,
            <SidebarItem href='/inbox'>
                <span className={s.link}><RiMailFill/>
                    Inbox<UnreadMessageIndicator/>
                </span>
            </SidebarItem>,
            <SidebarItem>
                <span onClick={() => {
                    clearSessionCookie();
                    window.location.href = '/login'
                }} className={s.link}><RiLogoutBoxLine/>
                    Logout
                </span>
            </SidebarItem>
        )
    }

    function toggleSidebar() {
        setSidebarShown(!sidebarShown)
    }

    return <div className={s.appContent}>
        <div className={s.mobileSidebar}>
            <div className={`${s.sidebarOverlay}`} style={{display: sidebarShown ? 'block' : 'none'}} onClick={toggleSidebar}/>
            <div className={`${s.sideBar} ${sidebarShown ? s.show : ''}`}>
                {items && items.map((item, idx) => (
                    <div key={idx} style={{color: 'white', marginBottom: idx === 0 ? '0' : '12px', fontSize: '26px'}}>
                        {item}
                    </div>
                ))}
            </div>
        </div>
        <div className={s.desktopSidebar}>
            <div className={s.sideBar}>
                {items && items.map((item, idx) => (
                    <div key={idx} style={{color: 'white', marginBottom: '2px', fontSize: '16px'}}>
                        {item}
                    </div>
                ))}
            </div>
        </div>
        <main className={`${sidebarShown ? s.mainSectionDisabled : s.mainSection}`}>
            <Header title={title} onMenuClick={() => setSidebarShown(true)} />
            <div className={s.mainSectionContent}>
                {props.children}
            </div>
        </main>
    </div>
}

export default (SideBarContainer);
